var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.inXL)?_c('span',{staticClass:"logout",on:{"click":function($event){_vm.$util.clickStat(`GWSY/WDYX/ZX`, `官网首页/我的游戏/注销`)
    _vm.$store.commit('logout')}}},[_vm._v(_vm._s(_vm.txt))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }